<template>
  <page-wrapper ref="pageEl" :title="title" :has-pad="true">
    <div class="mb-4 text-end">
      <sc-button
        :route="{ name: 'AppointmentCreatePage' }"
        class="btn-create"
        variant="secondary"
        hidden
        >นัดวันแทนลูกบ้าน</sc-button
      >
      <sc-button
:route="{
        name: 'AppointmentListPage',
        query: { pageType }
      }" variant="primary"
        >ไปหน้าค้นหา</sc-button
      >
    </div>
      <div class="mb-4 text-start">
      <el-checkbox
            v-model="isOnlyTestUserSuccessTab"
            @change="handleFindTestUser"
            ><p class="checkbox-font">
              ดูเฉพาะ User เทส
            </p>
          </el-checkbox>
    </div>
    <div v-if="!isProductPage" class="row mb-4">
      <div class="col-lg-3">
        <el-select
          :value="statusQuery"
          multiple
          placeholder="เลือกสถานะ"
          clearable
          @input="handleChangeStatusQuery"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="col-lg-3">
        <el-select
          :value="readQuery"
          placeholder="เลือกสถานะการอ่าน"
          clearable
          @input="handleChangeReadQuery"
        >
          <el-option
            v-for="item in readOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="paginate">
      <p v-if="visibleUpdatedAppointments.length" class="">
        {{ totalCount }}
      </p>
      <div class="text-end">
        <el-pagination
          :total="total"
          :size="10"
          :current-page="currentPage"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <div v-if="!isProductPage">
      <div class="alert alert-warning download-report-message">
        เลือก ช่วงเวลา ที่ต้องการก่อนกด Download Report
      </div>
      <div class="row mb-4">
        <div class="ms-3">
          <el-date-picker
            :value="dateTimeReport"
            class="date-picker"
            type="daterange"
            range-separator="ถึง"
            @input="handleChangeDate($event)"
          ></el-date-picker>
        </div>
        <div class="ms-3">
          <sc-button
            variant="secondary"
            @click="handleClickDownloadReport"
          >Download Report</sc-button>
        </div>
      </div>
    </div>
    <updated-appointment-row
      v-for="appointment in visibleUpdatedAppointments"
      v-bind="appointment"
      :key="appointment.id"
      @read="handleReadAppointment(appointment)"
    ></updated-appointment-row>
    <div v-if="!visibleUpdatedAppointments.length" class="text-center p-4">
      ไม่มีข้อมูล
    </div>
    <div class="text-end mt-4">
      <el-pagination
        :total="total"
        :size="10"
        :current-page="currentPage"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { Select, Option, Pagination, DatePicker, MessageBox } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import {
  convertBathToStangAndRoundTwoDecimal
} from "@/lib/formatter";
import { getDurationAppointmentTimeText } from "@/lib/dateTime";
import { serviceType } from "@/lib/mapper";
import UpdatedAppointmentRow from "../components/UpdatedAppointmentRow";

export default {
  name: 'AppointmentDashboardPage',
  components: {
    PageWrapper,
    UpdatedAppointmentRow,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-pagination": Pagination,
    "el-date-picker": DatePicker
  },
  props: {
    isProductPage: {
      type: Boolean,
      default: false
    },
    isReloadAppointmentDashboardPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const title = this.isProductPage ? "สินค้าเสร็จสิ้นล่าสุด" : "นัดหมายล่าสุด";
    const updatedAppointments = [];
    const statusOptions = [
      { label: "นัดใหม่", value: "CREATED" },
      { label: "ยืนยัน", value: "CONFIRMED" },
      { label: "ยกเลิก", value: "CANCELLED" },
      { label: "เสร็จสิ้น", value: "FULFILLED" }
    ];
    const readOptions = [
      { label: "อ่านแล้ว", value: "READ" },
      { label: "ยังไม่อ่าน", value: "NOT_READ" }
    ];
    const total = 0;
    const selectedDateTimeReport = null;
    const isOnlyTestUserSuccessTab = false;

    return {
      title,
      updatedAppointments,
      statusOptions,
      readOptions,
      total,
      selectedDateTimeReport,
      isOnlyTestUserSuccessTab
    };
  },
  computed: {
    visibleUpdatedAppointments() {
      return this.updatedAppointments;
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10) || 1;
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.updatedAppointments.length;
      const isLastPage = limit > currentTotalItem;
      const end = (isLastPage
        ? total
        : this.currentPage * limit
      ).toLocaleString();
      const start = (
        (isLastPage ? limit * this.currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    readQuery() {
      const { isRead = null } = this.$route.query;

      if (isRead === null) {
        return null;
      }

      if (isRead) {
        return "READ";
      }

      return "NOT_READ";
    },
    statusQuery() {
      const { status = [] } = this.$route.query;

      return status;
    },
    dateTimeReport() {
      if (!this.selectedDateTimeReport) {
        return null;
      }

      const { from, to } = this.selectedDateTimeReport;

      return [from.setZone("local").toJSDate(), to.setZone("local").toJSDate()];
    },
    pageType() {
      return this.isProductPage
        ? serviceType.PRODUCT
        : serviceType.SERVICE
    }
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    isReloadAppointmentDashboardPage() {
      this.setup();

      this.$emit("reloadAppointmentDashboardPage")
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupIsUserTest();
      this.setupData();
    },
    async setupData() {
      const { count, notices: data } = await this.fetchData();

      this.total = count;
      this.updatedAppointments = data.map(notice => {
        const { appointment, id } = notice;
        const service = appointment.service.name;
        const provider = appointment.provider.name;
        const user = {
          name: `${appointment.user.first_name} ${appointment.user.last_name}`,
          phoneNumber: appointment.user.mobile_number
        };
        const home = {
          addressNumber: appointment.home ? appointment.home.address_no : "",
          project: appointment.project
            ? `${appointment.project.project_code} โครงการ${appointment.project.project_name}`
            : ""
        };
        const appointmentId = notice.appointment_id;
        const dateTime = DateTime.fromISO(appointment.date_time);
        const {status} = notice;
        const servicetype = 'NOTHOMEOS';
        const currentReceiptDate = notice.appointment.receipt_date;
        const receiptNumber = notice.appointment.receipt_number;
        const actualCost = notice.appointment.actual_cost !== null
          ? convertBathToStangAndRoundTwoDecimal(notice.appointment.actual_cost)
          : null;
        const mainOption = notice.appointment.main_option || null;
        const extraOption = notice.appointment.extra_option || null;
        const currentAppointmentTime = getDurationAppointmentTimeText(
          appointment.date_time || null,
          appointment.date_time_end || null
        )
        const canNotEditAppointmentCost = notice.appointment.is_generate_sap_mm_report === true

        return {
          id,
          service,
          provider,
          user,
          home,
          dateTime,
          status,
          servicetype,
          isRead: !!notice.read_at,
          route: {
            name: "AppointmentDetailPage",
            params: { id: appointment.id }
          },
          appointmentId,
          currentReceiptDate,
          receiptNumber,
          actualCost,
          mainOption,
          extraOption,
          currentAppointmentTime,
          canNotEditAppointmentCost
        };
      });
    },
    async setupIsUserTest() {
      const { isOnlyTestUserSuccessTab } = this.$route.query;
      this.isOnlyTestUserSuccessTab = isOnlyTestUserSuccessTab === "true";
    },
    async fetchData() {
      const response = await baanRueJaiClient.admin.subscriptions.appointments.getNotices(
        {
          appointmentType: this.isProductPage ? 'PRODUCT' : 'SERVICE',
          servicetype: 'NOTHOMEOS',
          ...this.$route.query
        }
      );

      return response.data.result;
    },
    async handleFindTestUser() {
      const query = {
       'isOnlyTestUserSuccessTab' : this.isOnlyTestUserSuccessTab || false
      }

      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, ...query, page: 1, productPage: 1 },
      };

      this.$router.replace(route);
    },
    async handleReadAppointment(appointment) {
      try {
        await MessageBox.confirm("ยืนยันว่าอ่านแล้ว", { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" });
      } catch { return; }

      const ids = [appointment.id];
      await baanRueJaiClient.admin.subscriptions.appointments.postNoticesRead({
        ids
      });

      this.updatedAppointments = this.updatedAppointments.map(app => {
        const isRead = app.id === appointment.id;

        return isRead
          ? {
              ...app,
              isRead: true
            }
          : app;
      });
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    handleChangeReadQuery(value) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: 1 }
      };

      if (!value) {
        delete route.query.isRead;
      } else {
        route.query.isRead = value === "READ";
      }

      this.$router.replace(route);
    },
    handleChangeStatusQuery(status) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, status, page: 1 }
      };

      this.$router.replace(route);
    },
    handleChangeDate(value) {
      if (!value) {
        this.selectedDateTimeReport = null;
        return;
      }
      const [fromJSDate, toJSDate] = value;
      const from = DateTime.fromJSDate(fromJSDate).startOf("day").toUTC();
      const to = DateTime.fromJSDate(toJSDate)
        .endOf("day")
        .toUTC();

      this.selectedDateTimeReport = { from, to };
    },
    async handleClickDownloadReport() {
      const { from, to } = this.selectedDateTimeReport;

      try {
        const response = await baanRueJaiClient.admin.subscriptions.appointments.getReport(
          { start_at: from.toISO(), end_at: to.toISO() }
        );

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `fullfill-appointment-${from.toISODate()}-${to.toISODate()}.xlsx`;
        link.click();
      } catch {
        this.$message.error("ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-create {
  float: left;
}

.download-report-message {
  font-size: 15px;
}

.paginate {
  display: flex;
  justify-content: space-between;
}
</style>
